<li class='productFeatureContainer'>
    <b *ngIf="title !== ''" >{{title}}&nbsp;</b>
    <span *ngIf="description !==''">{{description}}</span>
</li>
